<template>
  <a-tooltip :title="isGlobalDownloading ? '': 'Reproducir'">
    <a-button
      type="link"
      class="delete"
      @click="openModal"
      :loading="downloading"
      :disabled="isGlobalDownloading"
    >
      <template #icon>
        <PlayCircleOutlined 
          :style="{
            fontSize: '20px',
          }"
        />
      </template>
    </a-button>
  </a-tooltip>

  <!-- Modal -->
  <a-modal 
    width="484px"
    v-model:open="visible" 
    :footer="null" 
    centered
    destroyOnClose
    @afterClose="onAfterClose"
  >
    <template #title>Datos del audio</template>
    <div class="container">
      <p><span>Fecha y hora:</span> {{ formatDate(record.call_start_date) }} a las {{ formatTime(record.call_start_date) }}</p>

      <p>
        <span>Duración de llamada:</span> 
        {{ record.billsec }}
        <a-tooltip title="Indica el tiempo de la duración total de la llamada en vivo.">
          <InfoCircleOutlined style="margin-left: 5px" />
        </a-tooltip>
      </p>

      <p>
        <span>Tiempo de grabación:</span> 
        {{ durationLabel || '0:00' }}
        <a-tooltip title="El tiempo de grabación puede variar su duración según el tipo de marcación.">
          <InfoCircleOutlined style="margin-left: 5px" />
        </a-tooltip>
      </p>

      <p><span>Tipo de marcación:</span> {{ record.type_dialing }}</p>
      <p><span>Disposición:</span> {{ record.disposition }}</p>
      <p><span>Origen:</span> {{ record.source }}</p>
      <p><span>Usuario:</span> {{ record.user?.fullname }}</p>
      <p><span>Destino:</span> {{ record.destination }}</p>
      <p><span>Empresa:</span> {{ record.entity?.name }}</p>
      <p><span>Campaña:</span> {{ record.portfolio?.name }}</p>
    </div>

    <CallAudioPlayer :audio-url="audioUrl" :rate-items="rateItems" @metadata="onPlayerMetadata"/>

  </a-modal>
</template>

<script setup>
import { ref, toRefs } from "vue";
import { message } from "ant-design-vue";

import { downloadRecord } from "@/app/supervision/services";
import CallAudioPlayer from "../audio/CallAudioPlayer.vue";
import { PlayCircleOutlined, InfoCircleOutlined } from "@ant-design/icons-vue";
import { hourReminder, dateTimeToSlashFormat } from "@/app/shared/utils/dates";
import { useGlobalDownloadState } from "@/app/shared/composables/useGlobalDownloadState";

const props = defineProps({
  record: Object,
});

const { record } = toRefs(props);

const visible = ref(false);
const audioUrl = ref("");
const rateItems = [
  { value: 0.25, label: "0.25x" },
  { value: 0.5,  label: "0.5x"  },
  { value: 0.75, label: "0.75x" },
  { value: 1,    label: "1x (Normal)" },
  { value: 1.25, label: "1.25x" },
  { value: 1.5,  label: "1.5x"  },
  { value: 1.75, label: "1.75x" },
  { value: 2,    label: "2x"    },
];
const durationLabel = ref("");
const downloading = ref(false);
const { isGlobalDownloading } = useGlobalDownloadState();

const openModal = async () => {
  downloading.value = true;
  try {
    const blob = await downloadRecord(props.record.id);
    audioUrl.value = URL.createObjectURL(blob);
    visible.value = true;
  } catch (e) {
    message.warning("No se pudo reproducir el audio");
  }
  downloading.value = false;
};

const onPlayerMetadata = ({ label }) => {
  durationLabel.value = label;   
};

const onAfterClose = () => {
  if (audioUrl.value) {
    URL.revokeObjectURL(audioUrl.value);
    audioUrl.value = "";
  }
  durationLabel.value = "";  
};

const formatDate = (date) => dateTimeToSlashFormat(date, false);
const formatTime = (time) => hourReminder(time);
</script>

<style scoped lang="sass">
.delete
  padding: 0

.container
  color: #262626E0
  font-size: 14px
  line-height: 22px
  margin-top: 20px
  margin-bottom: 20px
  p
    margin: 0 0 6px
  span
    font-weight: 600
</style>
